// extracted by mini-css-extract-plugin
export default {"wrapper":"lgZVjP","container":"Fu5_Cy","isCentered":"v0JTTi","alwaysLtr":"B_qxXz","alwaysHorizontal":"yZ_P90","buttonWrapper":"DQm4Sp","button":"iYa7pj"};